export const MAC_ADDRESS_WITH_MASK = 17
export const ALLOWED_MAC_ADDRESS_CHARACTERS = new Set([
  '0',
  '1',
  '2',
  '3',
  '4',
  '5',
  '6',
  '7',
  '8',
  '9',
  'a',
  'b',
  'c',
  'd',
  'e',
  'f',
  'A',
  'B',
  'C',
  'D',
  'E',
  'F',
])
